import { ClinicContentBlockType } from './ClinicContentBlockType'

export class ClinicContentBlock {
  key: string = ''
  clinic_key: string = ''
  block_type: ClinicContentBlockType = new ClinicContentBlockType()
  order: number = 0
  is_published: boolean = true
  is_collapsible: boolean = false
  title: string | null = null
  body_text: string | null = null
  video_path: string | null = null
  video_preview_path: string | null = null
  image_path: string | null = null
  button_text: string | null = null
  button_url: string | null = null
  contact_name: string | null = null
  contact_function: string | null = null
  contact_phone: string | null = null
  contact_email: string | null = null
  contact_note: string | null = null
  contact_area: string | null = null
  contact_area_custom: string | null = null
  logo_path: string | null = null
  street: string | null = null
  postal_code: string | null = null
  city: string | null = null
  phone: string | null = null
  website: string | null = null
  created_at: string = ''
  updated_at: string = ''
}
